import React from "react";
import { Outlet } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";

const DealerOutlet = () => {
  useCrumb("/dealers/", {
    to: `/dealers`,
    text: "Dealers",
  });
  return <Outlet />;
};

export default DealerOutlet;
